module.exports = __webpack_public_path__ + "static/img/34.0c0b726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/34.png
// module id = aDHm
// module chunks = 1